<div class="inline" [ngClass]="{'hidden timer-container': !isVisible()}" *ngIf="timer && timeInSeconds && timeInSeconds > 0">
    <span *ngIf="showSign" class="timer-sign">-</span>
    <span [ngClass]="{'timer-value': true, 'rosso': isInExtraTime()}">{{timer.displayTime}}</span>
</div>